import { motion } from "framer-motion";
import { SERVICES } from "../data";

export const Services = () => (
  <section id="leistungen" className="bg-[#F5F4F1] py-24 sm:py-32" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
      >
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A3C1A]" data-testid="services-headline">
          Was wir für Sie tun.
        </h2>
        <p className="mt-4 text-[#666666] text-base md:text-lg max-w-2xl">
          Von der Dachsanierung bis zum Hallenbau — alles aus einer Hand.
        </p>
      </motion.div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.title}
              className="service-card rounded-lg p-7"
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              data-testid={`service-card-${i}`}
            >
              <div className="service-icon inline-flex items-center justify-center w-12 h-12 rounded-lg bg-[#2A5C2A]/10">
                <Icon size={24} className="text-[#2A5C2A]" strokeWidth={2} />
              </div>
              <h3 className="mt-5 font-heading font-bold text-lg text-[#1A3C1A]">{s.title}</h3>
              <p className="mt-2 text-sm md:text-base text-[#666666] leading-relaxed">{s.text}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
